import { ref } from 'vue'
import { defineStore } from 'pinia'
import { useRpcapi } from '../../pinia.js'

const name = 'event'
export const useEventStore = defineStore(name, () => {
  const rpcapi = useRpcapi()
  const events = {}

  return {
    get (sid) {
      let item = events[sid]
      if (!item) {
        const event = ref(null)
        item = events[sid] = event

        rpcapi.getEvent({
          sid
        }).then((result) => {
          event.value = result
        })
      }

      return item
    }
  }
})
